import { loanConformingLimitsApi, pricingWorkbenchApi } from 'app/services/api';

import { PricingWorkbenchResponseType } from 'constants/pricingWorkbench';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const PRICING_ACTION_TYPE = createNamedActions('pricing', {
  CREATE_PRICING: 'CREATE_PRICING',
  GET_COUNTIES_BY_STATE: 'GET_COUNTIES_BY_STATE',
  GET_PRICING_WORKBENCH_LOAN_DATA: 'GET_PRICING_WORKBENCH_LOAN_DATA',
  SET_IS_LOAN_NOT_QUALIFIED_PROGRAMS_HIDDEN: 'SET_IS_LOAN_NOT_QUALIFIED_PROGRAMS_HIDDEN',
});

const getSupportReferenceId = err => {
  const error = err?.response?.data?.error;

  return error?.id ?? err?.response?.data?.supportTicketId ?? null;
};

const dispatchPricingError = (dispatch, err) =>
  dispatch({
    type: PRICING_ACTION_TYPE.CREATE_PRICING,
    payload: {
      responseType: PricingWorkbenchResponseType.ERROR,
      id: getSupportReferenceId(err),
      statusCode: err?.response?.status ?? null,
      errorMessage: err?.response?.data?.error?.message ?? null,
    },
  });

export const createPricingAction = params => async dispatch => {
  try {
    const { data } = await pricingWorkbenchApi.createPricingV2(params);

    return dispatch({
      type: PRICING_ACTION_TYPE.CREATE_PRICING,
      payload: data,
    });
  } catch (err) {
    return dispatchPricingError(dispatch, err);
  }
};

export const getCountiesByStateAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await pricingWorkbenchApi.getCounties(params);

  return dispatch({
    type: PRICING_ACTION_TYPE.GET_COUNTIES_BY_STATE,
    payload: data,
  });
});

// FHFA conforming loan limits by state/county/units — read-only reference lookup, not stored in
// Redux (a single consumer reads the resolved value). Callers pass `silent: true` so a failed
// lookup falls back to the local constant instead of surfacing a global error toast.
export const getLoanConformingLimitsAction = catchAsyncActionError(params => async () => {
  const { data } = await loanConformingLimitsApi.getLoanLimits(params);

  return data;
});

export const getPricingWorkbenchLoanDataAction = params => async dispatch => {
  const { data } = await pricingWorkbenchApi.getLoan(params);

  return dispatch({
    type: PRICING_ACTION_TYPE.GET_PRICING_WORKBENCH_LOAN_DATA,
    payload: data,
  });
};

export const getPricingWorkbenchApplicationDataAction = params => async dispatch => {
  const { data } = await pricingWorkbenchApi.getApplication(params);

  return dispatch({
    type: PRICING_ACTION_TYPE.GET_PRICING_WORKBENCH_LOAN_DATA,
    payload: data,
  });
};

export const setIsLoanNotQualifiedProgramsHiddenAction = isQualified => ({
  type: PRICING_ACTION_TYPE.SET_IS_LOAN_NOT_QUALIFIED_PROGRAMS_HIDDEN,
  payload: isQualified,
});
